import React, { FunctionComponent } from 'react';
import styles from '../../../../styles/ArticleContent.module.scss';

type Props = {
    content: string;
};

const removeWrapper = (content: string) => {
    return content.replace(/(<\/?blockquote>)/g, '');
};

export const Quote: FunctionComponent<Props> = ({ content }) => {
    content = removeWrapper(content);

    return (
        <blockquote className={`${styles.quoteBlock} p-4`} dangerouslySetInnerHTML={{ __html: content }}></blockquote>
    );
};
